import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5bfd9e5c"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _createTextVNode(" 消息 ");
const _hoisted_2 = { class: "message_container" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "notify" }, "站内消息通知", -1));
const _hoisted_4 = {
    key: 0,
    class: "message_list"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { class: "title" };
const _hoisted_7 = { class: "message_icon_box" };
const _hoisted_8 = {
    key: 0,
    class: "dot"
};
const _hoisted_9 = { class: "text" };
const _hoisted_10 = { class: "time" };
const _hoisted_11 = {
    key: 1,
    class: "no_data_box"
};
import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import day from "dayjs";
import { getMsg } from "@/utils";
import NoData from "@/components/NoData/index.vue";
import { readMessage, getMessageList } from "@/service/message";
import { useRoute } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    props: {
        unReadCount: { default: 0 }
    },
    emits: ["readMessage"],
    setup(__props, { emit }) {
        const props = __props;
        const route = useRoute();
        // 路由跳转
        const router = useRouter();
        const messageDrop = ref();
        const seeMessage = () => {
            router.push("/message/index");
            messageDrop.value.handleClose();
        };
        const goDetail = (row) => {
            emit("readMessage");
            router.push({ path: "/message/detail", query: { id: row.id } });
            messageDrop.value.handleClose();
        };
        //判断字符串长度
        const getActualWidthOfChars = (text, options) => {
            const { size = 14, family = "PingFang SC" } = options || {};
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d") || {};
            ctx.font = `${size}px ${family}`;
            const metrics = ctx.measureText(text);
            const actual = Math.abs(metrics.actualBoundingBoxLeft) +
                Math.abs(metrics.actualBoundingBoxRight);
            return Math.max(metrics.width, actual);
        };
        const messageActive = computed(() => {
            return route.matched[0].name === "message";
        });
        const visible = ref(false);
        const readAll = async () => {
            await readMessage({ is_all: 1 });
            emit("readMessage");
            getDataList();
            getMsg("全部已读");
            messageDrop.value.handleClose();
        };
        const messageList = ref([]);
        const getDataList = async (val) => {
            visible.value = val || false;
            const res = await getMessageList({ page_size: 5 });
            messageList.value = res.data.message_list;
            res.data.message_list.map((item) => {
                if (day(item.created_at).format("YYYY") ===
                    new Date().getFullYear() + "") {
                    item.created_at = day(item.created_at).format("MM-DD");
                }
                else {
                    item.created_at = day(item.created_at).format("YYYY-MM-DD");
                }
            });
        };
        onMounted(() => {
            getDataList();
        });
        return (_ctx, _cache) => {
            const _component_svg_icon = _resolveComponent("svg-icon");
            const _component_el_dropdown = _resolveComponent("el-dropdown");
            const _directive_loading = _resolveDirective("loading");
            return (_openBlock(), _createBlock(_component_el_dropdown, {
                ref_key: "messageDrop",
                ref: messageDrop,
                class: "dropdown_container",
                "popper-class": "my-dropdown-popper-arrow",
                onVisibleChange: getDataList
            }, {
                dropdown: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", { class: "top_bar" }, [
                            _hoisted_3,
                            _createElementVNode("div", null, [
                                _createElementVNode("span", {
                                    class: "top_bar-right ele-hover",
                                    onClick: readAll
                                }, "全部已读")
                            ])
                        ]),
                        (messageList.value.length)
                            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageList.value, (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: item.id,
                                        class: "message_content",
                                        style: _normalizeStyle({
                                            height: getActualWidthOfChars(item.title) > 100 ? '54px' : '36px'
                                        }),
                                        onClick: _withModifiers(($event) => (goDetail(item)), ["stop"])
                                    }, [
                                        _createElementVNode("span", _hoisted_6, [
                                            _createElementVNode("div", _hoisted_7, [
                                                _createVNode(_component_svg_icon, {
                                                    class: "message2-icon",
                                                    "icon-class": "message2"
                                                }),
                                                (item.status === 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("span", _hoisted_9, _toDisplayString(item.title), 1)
                                        ]),
                                        _createElementVNode("span", _hoisted_10, _toDisplayString(item.created_at), 1)
                                    ], 12, _hoisted_5));
                                }), 128))
                            ])), [
                                [_directive_loading, !messageList.value.length]
                            ])
                            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(NoData, { "icon-class": "message2" })
                            ]))
                    ]),
                    _createElementVNode("div", {
                        class: "more ele-hover",
                        onClick: seeMessage
                    }, "查看全部")
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        class: _normalizeClass([
                            'menu-item display-flex align-items',
                            _unref(messageActive) || visible.value ? 'active' : ''
                        ])
                    }, [
                        _hoisted_1,
                        (props.unReadCount)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(['badge', props.unReadCount < 10 ? 'readCount' : ''])
                            }, _toDisplayString(props.unReadCount), 3))
                            : _createCommentVNode("", true)
                    ], 2)
                ]),
                _: 1
            }, 512));
        };
    }
});
